import SectionContainer from 'components/common/SectionContainer';
import useLocaleLink from 'hooks/useLocaleLink';
import { useTranslations } from 'next-intl';
import type { SupportChannel } from 'types/help-center';
import EditPenIcon from '@/public/images/icons/edit-pen.svg';
import TermsBookIcon from '@/public/images/icons/terms-book.svg';

const ICON_MAP: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  edit: EditPenIcon,
  'book-fill': TermsBookIcon,
};

interface SupportSectionProps {
  channels: SupportChannel[];
}

export default function SupportSection({ channels }: SupportSectionProps) {
  const t = useTranslations('support');
  const localeLink = useLocaleLink();

  return (
    <SectionContainer>
      <h2 className="mb-10 text-[32px] font-bold leading-[40px] text-base-label pad:text-5xl">
        {t('needMoreSupport')}
      </h2>
      <div className="grid grid-cols-1 gap-4 pad:grid-cols-2 pad:gap-6">
        {channels.map((channel) => (
          <a
            key={channel.title}
            href={`${localeLink}${channel.href}`}
            className="group flex items-center justify-between gap-4 overflow-hidden rounded-2xl border border-base-line-primary p-4 backdrop-blur-sm transition-colors dark:border-transparent dark:bg-base-hover-fill-primary dark:hover:bg-base-fill-secondary pad:px-8 pad:py-6"
          >
            <div className="flex flex-1 flex-col gap-3">
              <h3 className="text-xl font-medium leading-[30px] text-base-label transition-colors group-hover:text-base-primary">
                {t(channel.title)}
              </h3>
              <p className="text-base leading-6 text-base-label-40">{t(channel.description)}</p>
            </div>
            {channel.icon && ICON_MAP[channel.icon] && (
              <div className="hidden size-[112px] shrink-0 items-center justify-center rounded-3xl bg-base-fill-secondary transition-colors dark:group-hover:bg-base-hover-fill-secondary pad:flex">
                {(() => {
                  const Icon = ICON_MAP[channel.icon!];
                  return <Icon className="size-12 text-base-label" />;
                })()}
              </div>
            )}
          </a>
        ))}
      </div>
    </SectionContainer>
  );
}
